import script from "./SectionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionModal.vue?vue&type=script&setup=true&lang=ts"

import "./SectionModal.vue?vue&type=style&index=0&id=3fde3342&lang=css"

const __exports__ = script;

export default __exports__